import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Install axios interceptors early (attaches JWT + redirects on 401)
import "./api/axios";

// Authentication Pages
import Login from "./pages/Login";
import ForgetPassword from "./pages/ForgetPassword";
import Otp from "./pages/Otp";
import ResetPassword from "./pages/ResetPassword";

// Dashboard
import Dashboard from "./pages/Dashboard";

// Public
import PublicBooking from "./pages/PublicBooking";

// Dashboard Pages
import Customer from "./dashboard/pages/Customer";
import ViewProfile from "./dashboard/pages/ViewProfile";
import Stock from "./dashboard/pages/Stock";
import Bookings from "./dashboard/pages/Bookings";
import Invoice from "./dashboard/pages/Invoice";
import Camp from "./dashboard/pages/Camp";
import FollowUps from "./dashboard/pages/FollowUps";

// Dashboard Sections
import AddCustomer from "./dashboard/section/AddCustomer";

// Layout
import Layout from "./components/Layout";

// Route guard — requires JWT token
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Authentication */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Public — customer self-booking (no auth) */}
        <Route path="/book" element={<PublicBooking />} />

        {/* Dashboard — protected */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Bookings */}
          <Route path="/bookings" element={<Bookings />} />

          {/* Customers */}
          <Route path="/customer" element={<Customer />} />
          <Route path="/customer/:id" element={<ViewProfile />} />
          <Route path="/add-customer" element={<AddCustomer />} />
          <Route path="/edit-customer/:id" element={<AddCustomer />} />

          {/* Stock */}
          <Route path="/stock" element={<Stock />} />

          {/* Camp screening */}
          <Route path="/camp" element={<Camp />} />

          {/* Follow-ups */}
          <Route path="/followups" element={<FollowUps />} />

          {/* Invoice */}
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/invoice/:customerId" element={<Invoice />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
